// @ts-nocheck
import { FormFieldPresentationPropsCommon } from "@insite/mobius/FormField";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
// import { linkActionStyles } from "@store/Themes/common/mixins/link"; // Store Custom Code
// import { inlineSeparatorStyles } from "@store/Themes/common/mixins/typography"; // Store Custom Code
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import updateCssValue, { Operators } from "@toolkit/Framework/Common/Utilities/updateCssValue";
import { gridGapStyles, gridPresetGapStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { FormFieldPresentationProps } from "@insite/mobius/FormField";
import { IconPresentationProps } from "@insite/mobius/Icon";
import { TextFieldPresentationProps } from "@insite/mobius/TextField";
import getColor from "@insite/mobius/utilities/getColor";
import { customBorderTypes } from "@store/Extensions/Mobius/FormField/formStyles";
import { linkActionStyles } from "@store/Themes/common/mixins/link";
import { inlineSeparatorStyles } from "@store/Themes/common/mixins/typography";
/* Store Custom Code - End */

export interface FormGridProps {
    gridContainer: GridContainerProps;
    innerGridContainer: GridContainerProps;
    formField?: FormFieldPresentationPropsCommon;
    title?: TypographyPresentationProps;
    labelSeparated?: TypographyPresentationProps;
    labelLink?: LinkPresentationProps;
}

const sharedGridProps: Partial<FormGridProps> = {
    title: {
        variant: "h5",
        forwardAs: "h2",
        css: css`
            font-size: ${pxToRem(18)};
            margin-top: 1.2em;
        `,
    },
    labelSeparated: {
        css: inlineSeparatorStyles({ spacing: pxToRem(16) }),
    },
    labelLink: {
        css: css`
            ${linkActionStyles()}
            vertical-align: middle;
        `,
    },
};

export const formGridProps: FormGridProps = {
    ...sharedGridProps,
    gridContainer: {
        gap: 0,
        css: css`
            ${x => gridPresetGapStyles(x.theme.design.form.grid.base)}
        `,
    },
    innerGridContainer: {
        gap: 0,
        css: css`
            ${({ theme }) => {
                return gridGapStyles(
                    theme.design.form.grid.base.horizontal.map(x => updateCssValue(x, Operators.Divide, 2)),
                    theme.design.form.grid.base.vertical,
                );
            }}
        `,
    },
};

export const formSmallGridProps: FormGridProps = {
    ...sharedGridProps,
    gridContainer: {
        gap: 0,
        css: css`
            ${x => gridPresetGapStyles(x.theme.design.form.grid.small)}
        `,
    },
    innerGridContainer: {
        gap: 0,
        css: css`
            ${({ theme }) => {
                return gridGapStyles(
                    theme.design.form.grid.small.horizontal.map(x => updateCssValue(x, Operators.Divide, 2)),
                    theme.design.form.grid.small.vertical,
                );
            }}
        `,
    },
    formField: {
        sizeVariant: "small",
    },
};

/* Store Custom Code - Start */
export const formAltFieldProps: FormFieldPresentationProps<any> = {
    cssOverrides: {
        inputSelect: css`
            ${x => x.theme.formField.defaultProps?.cssOverrides?.inputSelect}
            background-color: ${getColor("common.accent")};
        `,
    },
};

export const formGetAltTextFieldProps = (
    src?: IconPresentationProps["src"],
    size?: string,
): TextFieldPresentationProps => {
    let iconProps;

    if (src) {
        iconProps = {
            src,
            css: css`
                /* Required to override calculated styles */
                &:not(#important) {
                    color: ${getColor("primary")};
                    padding: 0;
                    width: 100%;
                    justify-content: center;
                    right: ${customBorderTypes.inactive.width}px;
                }

                ${() => {
                    if (size) {
                        return css`
                            svg {
                                width: ${size};
                                height: ${size};
                            }
                        `;
                    }
                }}
            `,
        };
    }

    return {
        ...formAltFieldProps,
        iconProps,
    };
};
/* Store Custom Code - End */
